import { z } from "zod";

export enum ApprovedStateTypeEnum {
    APPROVED_FOR_TESTING = 1,
    APPROVED_FOR_USAGE = 2,
    APPROVED_FOR_TESTING_AND_USAGE = 3
}

export const ApprovedStateTypeEnumSchema = z.nativeEnum(ApprovedStateTypeEnum);
export type ApprovedStateTypeEnumSchema = z.infer<typeof ApprovedStateTypeEnumSchema>;